<head>
    <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
        />
</head>

<div class="dashboard-panel-container">
    <div class="custom-container">
        <div class="cards-grid">
            <mat-card class="config-card" *ngIf="'ControlUsuarios' | permissionFilter">
                <mat-icon>group</mat-icon>
                <mat-card-title>Usuarios</mat-card-title>
                <p>Control de Usuarios</p>
                <button mat-raised-button color="primary" [routerLink]="'/users'">Entrar</button>
            </mat-card>

            <mat-card class="config-card" *ngIf="'ControlRoles' | permissionFilter">
                <mat-icon>key</mat-icon>
                <mat-card-title>Permisos</mat-card-title>
                <p>Control de Permisos</p>
                <button mat-raised-button color="primary" [routerLink]="'/roles'">Entrar</button>
            </mat-card>

            <mat-card class="config-card">
                <mat-icon>login</mat-icon>
                <mat-card-title>Bitácora de Sesiones</mat-card-title>
                <p>Bitácora de Sesiones</p>
                <button mat-raised-button color="primary" [routerLink]="'/userLogs'">Entrar</button>
            </mat-card>

            <mat-card class="config-card" *ngIf="'ControlAlarmasSistema' | permissionFilter">
                <mat-icon>alarm</mat-icon>
                <mat-card-title>Alarmas de sistema</mat-card-title>
                <p>Control de Alarmas de Sistema</p>
                <button mat-raised-button color="primary" [routerLink]="'/systemAlarms'">Entrar</button>
            </mat-card>
        </div>
    </div>
</div>